exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-f1d54c2c] {\n  margin-top: 12px !important;\n  font-weight: normal;\n}\n#divCont[data-v-f1d54c2c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.fle[data-v-f1d54c2c] {\n  margin: 1.8rem 1rem;\n  width: 20rem;\n}\n", ""]);

// exports
